<a
  *ngIf="serviceDetails == null"
  type="button"
  (click)="loadRequestDetails()"
  (keydown.enter)="loadRequestDetails()"
  class="ds-btn-link text-decoration-none"
  tabindex="0"
>
  <i class="fi-arrow-thin-down fi-large mr-2"></i>
  <span [innerText]="'trRequestCardMoreDetails' | translate"></span>
</a>

<tabset *ngIf="serviceDetails">
  <tab [heading]="'trRequestCardOutputs' | translate" class="mt-4">
    <div
      class="form-section"
      *ngIf="
        serviceDetails.citesOutputs && serviceDetails.citesOutputs.length > 0
      "
    >
      <app-cites-outputs
        [outputs]="serviceDetails.citesOutputs"
        (verificationDoc)="downloadVerificationDocument($event)"
      >
      </app-cites-outputs>
    </div>
  </tab>
  <tab [heading]="'trRequestCardReceipts' | translate" class="mt-4">
    <app-es-receipt-details
      [receipts]="serviceDetails.receipts"
      [showLegend]="false"
    ></app-es-receipt-details>
  </tab>
  <tab [heading]="'trRequestCardAttachments' | translate" class="mt-4">
    <app-es-attachments-details
      [attachments]="serviceDetails.attachments"
      [showLegend]="false"
    ></app-es-attachments-details>
  </tab>
</tabset>
